import { render, staticRenderFns } from "./FactoringCompanyDetail.vue?vue&type=template&id=4fb261fe&scoped=true&"
import script from "./FactoringCompanyDetail.vue?vue&type=script&lang=js&"
export * from "./FactoringCompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./FactoringCompanyDetail.vue?vue&type=style&index=0&id=4fb261fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb261fe",
  null
  
)

export default component.exports